import { useGetOneProvisionedSubscription } from "../api/generated/subscription-provisioning/subscription-provisioning";
import { toProvisionedSubscription } from "../functions/provisionedSubscription";

/**
 * One provisioned subscription, from `GET provisioning/subscriptions/:id`.
 *
 * The cache holds the raw DTO so a mutation's response can be written straight into it; the mapping
 * to lowercase `id` and Date fields happens here, on the way out.
 *
 * @param {string|undefined} id The subscription id; nothing is requested without one.
 *
 * @returns {{subscription: Object|null, isLoading: boolean, isError: boolean}} The mapped subscription,
 *          or null until it resolves.
 */
export default function useProvisionedSubscription( id ) {
	const { data, isLoading, isError } = useGetOneProvisionedSubscription( id, {
		query: { enabled: Boolean( id ) },
	} );

	return {
		subscription: data ? toProvisionedSubscription( data ) : null,
		isLoading,
		isError,
	};
}
